
import { useNavigate } from 'react-router-dom';
import { User, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Link } from 'react-router-dom';

export const DesktopAuthButtons = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async (event?: React.MouseEvent) => {
    if (event) {
      event.preventDefault();
    }
    
    await logout();
    navigate('/');
  };

  const handleNavigation = (path: string, event?: React.MouseEvent) => {
    if (event) {
      event.preventDefault();
    }
    navigate(path);
  };

  // Get user's first name or first initial
  const firstName = user?.user_metadata?.first_name || (user?.email ? user.email.split('@')[0] : 'User');
  const userInitial = (firstName || 'U').charAt(0).toUpperCase();

  return (
    <div 
      className="hidden md:flex items-center space-x-4"
      role="navigation" 
      aria-label="User authentication"
    >
      {isAuthenticated ? (
        <>
          <Link 
            to="/profile" 
            className="rounded-full flex items-center gap-2 px-4 py-2 hover:bg-accent transition-colors"
            aria-label="View your profile"
          >
            <Avatar className="h-8 w-8">
              <AvatarFallback className="bg-primary text-primary-foreground">
                {userInitial}
              </AvatarFallback>
            </Avatar>
            <span className="font-medium">{firstName}</span>
          </Link>
          <Button 
            variant="outline" 
            size="sm" 
            className="rounded-full px-4"
            onClick={(e) => handleLogout(e)}
            aria-label="Log out of your account"
          >
            Logout
          </Button>
        </>
      ) : (
        <>
          <Button 
            variant="outline" 
            size="sm" 
            className="rounded-full px-6 py-2 bg-gray-100 hover:bg-gray-200 border-0 text-gray-800"
            onClick={(e) => handleNavigation('/login', e)}
            aria-label="Log in to your account"
          >
            Login
          </Button>
          <Button 
            size="sm" 
            className="rounded-full px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white"
            onClick={(e) => handleNavigation('/sign-up', e)}
            aria-label="Join our beta program"
          >
            <Sparkles className="h-4 w-4 mr-1.5" />
            Join Beta
          </Button>
        </>
      )}
    </div>
  );
}
